'use strict';

class Switch {
    constructor(elem) {
        this.elem = elem;
        this.select = this.elem.querySelector('select');
        this.switchOptions = this.elem.querySelectorAll('.switch-option');
        this.events();
    }

    events() {
        this.switchOptions.forEach(option => {
            option.addEventListener('click', () => {
                this.setSelectedOption(option);
            });
        });
    }

    setSelectedOption(option) {
        this.switchOptions.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
        this.select.value = option.dataset.value;
        this.select.dispatchEvent(new Event('change'));
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const switchElems = document.querySelectorAll('.js-switch');
    for (let switchElem of switchElems) {
        switchElem.dropdown = new Switch(switchElem);
    }
});
